import { Table, TableBody, TableCell, TableContainer, TableContainerProps, TableRow, Typography } from '@mui/material'
import { ReactNode } from 'react'

export const DetailsTable = (props: {
  items: { key: string; label: ReactNode; content: ReactNode }[]
  tableContainerProps?: TableContainerProps
}) => {
  const { items, tableContainerProps = {} } = props
  return (
    <TableContainer
      {...tableContainerProps}
      sx={{
        '& .note-display h1:first-of-type': {
          marginTop: 0,
        },
        display: 'block',
        width: 'auto',
        ...(tableContainerProps.sx || {}),
      }}
    >
      <Table sx={{ width: 'auto' }} size="small">
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.key}>
              <TableCell component="th" scope="row" sx={{ textAlign: 'right', border: 'none', verticalAlign: 'top' }}>
                <strong>{item.label}</strong>
              </TableCell>
              <TableCell sx={{ border: 'none' }}>
                {item.content || (
                  <Typography color="textDisabled" fontSize="small" sx={{ cursor: 'default' }}>
                    --
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
